var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "operationFloor" }, [
        _c(
          "div",
          {
            staticClass: "imgBox",
            on: {
              mouseup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft",
                  ])
                ) {
                  return null
                }
                if ("button" in $event && $event.button !== 0) {
                  return null
                }
                $event.stopPropagation()
                return _vm.changeStop()
              },
            },
          },
          [
            _c(
              "div",
              {
                ref: "container",
                staticClass: "container",
                attrs: { id: "img-box-container" },
              },
              [
                _c("img", {
                  ref: "backgroundImg",
                  attrs: {
                    src: _vm.imgs[0].img,
                    ondragstart: "return false;",
                    oncontextmenu: "return false;",
                    onselect: "document.selection.empty();",
                    alt: "img",
                  },
                  on: {
                    mousedown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 0) {
                        return null
                      }
                      $event.stopPropagation()
                      return _vm.mouseDown($event)
                    },
                  },
                }),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.caseShow,
                      expression: "caseShow",
                    },
                  ],
                  staticClass: "area",
                  style: {
                    width: _vm.areaWidth + "px",
                    height: _vm.areaHeight + "px",
                    left: _vm.starX + "px",
                    top: _vm.starY + "px",
                  },
                }),
                _vm._l(_vm.areaData, function (item, index) {
                  return _c("AreaBox", {
                    key: "area" + index,
                    attrs: {
                      "area-data-index": index,
                      link: item.link,
                      title: item.title,
                      type: parseInt(item.type),
                      "area-init": item,
                      "parent-width": _vm.parentWidth,
                      "parent-height": _vm.parentHeight,
                    },
                    on: {
                      "update:areaInit": function ($event) {
                        item = $event
                      },
                      "update:area-init": function ($event) {
                        item = $event
                      },
                      delAreaBox: _vm.delAreaBox,
                      addURL: _vm.addURL,
                    },
                  })
                }),
              ],
              2
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "form" },
          [
            _vm._m(0),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.addAreaBox },
              },
              [_vm._v("添加热区")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.resetAreaBox } },
              [_vm._v("重置")]
            ),
            _vm._l(_vm.areaData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "form-row" },
                [
                  _c("el-input", {
                    staticClass: "item-input",
                    attrs: { maxlength: 6 },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                  _c("div", { staticClass: "form-item label" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.getLink(index)
                          },
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "toLink",
                            style: _vm.linkInputStyle,
                            attrs: {
                              value: item.link,
                              readonly: "",
                              placeholder: "选择跳转链接",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont iconlianjietubiao",
                              attrs: { slot: "suffix" },
                              slot: "suffix",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("i", {
                    staticClass: "el-icon-delete",
                    on: {
                      click: function ($event) {
                        return _vm.delAreaBox(index)
                      },
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "btn-footer" },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.btnDialog(0)
                  },
                },
              },
              [_vm._v("取消")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.btnDialog(1)
                  },
                },
              },
              [_vm._v("确定")]
            ),
          ],
          1
        ),
      ]),
      _c("linkaddress", { ref: "linkaddres", on: { linkUrl: _vm.linkUrl } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "acea-row row-middle" }, [
      _c("div", { staticClass: "mb12 titleTop acea-row row-middle" }, [
        _c("span", [_vm._v("热区管理")]),
        _c("span", { staticClass: "ml5 iconfont iconrequwenzitishi" }),
        _c("img", {
          staticClass: "ml5",
          attrs: { src: require("@/assets/imgs/qipaokuang.png"), alt: "" },
        }),
        _c("div", { staticClass: "ml5 title-text" }, [
          _vm._v("可框选热区范围，双击设置热区信息"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }